import { IRouteStore } from './RouteStore';

export class FeatureStore {
  private showHiddenFeatures = false;

  public constructor(private routeStore: IRouteStore) {
    this.showHiddenFeatures = routeStore.queryParam('show-hidden-features') === 'true';
  }
}
